// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".550.0.0." + {"1367": "8b8921dffc71da12","2257": "59ad52155e9c6c7e","2973": "d9c9c2c1da32a6ee","582": "af02603ae03c2e02","7530": "56f7894c1e8fda9c","7581": "58ef88d861fd8464","8692": "93ff9478ff88d0c9",}[chunkId] + ".css"
}